import ProductLogoImage from './ProductLogoImage';

export default ProductLogoImage;
